import apiClient, {
  requiredParams,
  optionalParams,
} from "@/services/apiClient";

export const DocumentService = {
  /**
   * @param {Object} [filters]
   * @param {string} [filters.search_string]
   * @param {number} [filters.page_number=1]
   * @param {number} [filters.page_size=10]
   * @param {boolean} [filters.disable_pagination]
   * @param {"it"|"en"} filters.language - obbligatorio: lingua in cui il backend restituisce i nomi delle categorie
   * @returns {Promise<ServiceResult>}
   */
  async getDocumentCategories({
    search_string,
    page_number = 1,
    page_size = 10,
    disable_pagination,
    language,
  } = {}) {
    try {
      requiredParams({ language });
      const params = {
        ...optionalParams({
          search_string,
          page_number,
          page_size,
          disable_pagination,
        }),
        language,
      };
      const { data } = await apiClient.get("documents/v2/category", {
        params,
      });
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e.userMessage ?? e.message };
    }
  },

  /**
   * @param {Object} [filters]
   * @param {string} [filters.search_string]
   * @param {string} [filters.category]
   * @param {string} [filters.from_date]
   * @param {string} [filters.to_date]
   * @param {boolean} [filters.read]
   * @param {number} [filters.page_number=1]
   * @param {number} [filters.page_size=10]
   * @param {boolean} [filters.disable_pagination]
   * @param {"it"|"en"} filters.language - obbligatorio: lingua in cui il backend restituisce i documenti
   * @returns {Promise<ServiceResult>}
   */
  async getDocuments({
    search_string,
    category,
    from_date,
    to_date,
    read,
    page_number = 1,
    page_size = 10,
    disable_pagination,
    language,
  } = {}) {
    try {
      requiredParams({ language });
      const params = {
        ...optionalParams({
          search_string,
          category,
          from_date,
          to_date,
          read,
          page_number,
          page_size,
          disable_pagination,
        }),
        language,
      };
      const { data } = await apiClient.get("documents/v2/document", { params });
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e.userMessage ?? e.message };
    }
  },

  /**
   * @param {number} document_id - obbligatorio
   * @param {number} category_id - obbligatorio
   */
  async downloadDocument(document_id, category_id) {
    try {
      requiredParams({
        document_id,
        category_id,
      });
      const { data } = await apiClient.get(
        `documents/v2/document/${document_id}/download`,
        { params: { category_id }, responseType: "blob" }
      );
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e.userMessage ?? e.message };
    }
  },
};
